export const addLogo = () => {
    const jobTiles = document.querySelectorAll(".attrax-vacancy-tile");

    if (!jobTiles) {
        return;
    }

    jobTiles.forEach((jobTile) => {
        let logoWrapper = document.createElement("div");
        logoWrapper.classList.add("attrax-vacancy-tile__logo-wrapper");
        jobTile.prepend(logoWrapper);
    });
};

export const logoReplacer = () => {
    const jobOptionClass: string = ".attrax-vacancy-tile--";

    //the options given should be the same name give to logos placed in the logo folder including the file extension
    const optionArray: Array<string> = ["germany", "france", "united-states"];

    optionArray.forEach((option) => {
        const className = jobOptionClass + option;

        if (document.getElementsByClassName(className)) {
            const filePath = `url("/Blob/images/logos/${option}")`;

            const foundClass: Element[] = Array.from(
                document.querySelectorAll(className)
            );

            foundClass.forEach((option) => {
                const parentTile: HTMLElement | null = option.closest(
                    ".attrax-vacancy-tile"
                );

                if (!parentTile) return;

                const logowrapper: HTMLElement | null = parentTile.querySelector(
                    ".attrax-vacancy-tile__logo-wrapper"
                );

                if (!logowrapper) return;
                
                logowrapper.style.backgroundImage = filePath;
            });
        }
    });
};

export const brandClassAssignment = () => {
    const brandtiles = document.querySelectorAll(
        ".attrax-vacancy-tile__option-brand"
    );

    if (!brandtiles) {
        return;
    }

    brandtiles.forEach((brandtile) => {
        const brandclass = [...brandtile.classList].find((el) =>
            el.includes("attrax-vacancy-tile__option-brand--")
        );

        if (!brandclass) {
            return;
        }

        const closestTile = brandtile.closest(".attrax-vacancy-tile");
        if (closestTile) {
            closestTile.classList.add(brandclass);
        }
    });
};

export const setActive = () => {
    const jobtiles = document.querySelectorAll(".attrax-vacancy-tile");

    if (!jobtiles) {
        return;
    }

    jobtiles.forEach((jobtile) => {
        jobtile.classList.add("attrax-vacancy-tile--active");
    });
};
